import React, { useState, useEffect } from "react";

import './ReturnResponse.css';

import { SvgChekedReturn, SvgErro } from "components/SvgFile";

import { RegisterModalData, RegisterModalObserver, SetModalState } from "interface/PopUp";

export default function PopUP_ReturnResponse(){

    const [ modalData, setModaldata ] = useState({});
    const [ showPopUp, setShowPopUp ] = useState(false);

    function ClosePopUp(){
        SetModalState('ReturnResponse', false);
    }

    function TypeData(){
        switch (modalData.page) {
            case 'missingData':
                return(
                    <>
                        <SvgErro color="#F00000" className="icons_return" />
                        <div className="title_return">
                            { modalData.text }
                        </div>
                    </>
                )

            case 'erro':
                return(
                    <>
                        <SvgErro color="#F00000" className="icons_return" />
                        <div className="title_return">
                            Error registering information, please try again!
                        </div>
                    </>
                )

            default:
                return(
                    <>
                        <SvgChekedReturn color="#43a047" className="icons_return" />
                        <div className="title_return">
                            Email sent successfully.
                        </div>
                    </>
                )
        }
    }

    useEffect(()=>{
        RegisterModalData('ReturnResponse', setModaldata);
        RegisterModalObserver('ReturnResponse', setShowPopUp);
    }, []);

    return(
        (showPopUp ?
            <div className="PopUp">
                <div className="all">
                    <div className="div_data">
                        <div className="content">
                            {
                                TypeData()
                            }
                            <div className="close_return" onClick={ ()=>{ ClosePopUp() } }>
                                OK
                            </div>
                        </div>
                    </div>
                </div>
                <div className="close_all" onClick={ ()=>{ ClosePopUp(); } } />
            </div>
        : <React.Fragment></React.Fragment>)
    )
};
